export const environment = {
  production: false,
  baseUrl: 'https://testing.wizefulfill.com/',
  chatbotUrl: "https://stage.bot.wizefulfill.com/",
  sellerCloudUrl: 'https://shtiks.api.sellercloud.com/rest/api/',
  authServiceUrl: 'https://api.testing.wizefulfill.com/auth_service',
  clientServiceUrl: 'https://api.testing.wizefulfill.com/client_service',
  spServiceUrl: 'https://api.testing.wizefulfill.com/wms_service',



  hubspot: {
      portalId: "45268756",
      hublet: "na1",
      environment: "prod",
      defaultChatFlow: "mobilechat",
    }
};